import { Card, Text } from "@overmap-ai/blocks"
import { type IssueTypeFieldValues, type Stored } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { IssueTimelineItemType } from "../../enums/issues"
import { issueTimelineItemTypeData } from "../../mappings/issues"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { IssueTimelineSize } from "./typings"

interface IssueTimelineFieldValuesItemProps {
	issueTypeFieldValues: Stored<IssueTypeFieldValues>
	size: IssueTimelineSize
}

export const IssueTimelineFieldValuesItem = memo<IssueTimelineFieldValuesItemProps>((props) => {
	const { issueTypeFieldValues, size } = props

	const createdBy = useAppSelector(selectUserById(issueTypeFieldValues.created_by ?? -1))

	const { icon } = issueTimelineItemTypeData[IssueTimelineItemType.FIELD_VALUES]

	return (
		<div className="flex w-full gap-4">
			<TimelineIconRail icon={icon} size={size} />
			<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
				<Text size={size} accentColor="base">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;updated field values
					<Text accentColor="base">
						&nbsp;&#8226;&nbsp;{formatCompactDate(issueTypeFieldValues.submitted_at)}
					</Text>
				</Text>
			</Card>
		</div>
	)
})
IssueTimelineFieldValuesItem.displayName = "IssueTimelineFieldValuesItem"
